<template>
	<span></span>
</template>
<script>
	export default {
		name: "BackendSimulator",
		methods: {
			simulate(){
				let tcrn
				let tset
				let state
				console.log("timestep")
				let self = this
				this.fiberNames.forEach(function(element){
					tcrn = self.ovens[element].tcrn
					tset = self.ovens[element].tset
					state = self.ovens[element].state

					if(state == 1){
						if(tcrn < tset){
						tcrn++
						}else{
							tcrn--
						}	
					}
					

					self.$store.dispatch("setOvenTcrn", {fiberType:element, value:tcrn})
			})
				//this.fiberNames.forEach(element =>console.log(element)
			},
			init(){
				console.log("init")

				this.$store.dispatch('setfiberName', {x:6, y:1, value:"PMT_01"})
				this.$store.dispatch('setfiberType', {x:6, y:1, value:"PMT"})

				this.$store.dispatch('setfiberName', {x:7, y:0, value:"PMT_02"})
				this.$store.dispatch('setfiberType', {x:7, y:0, value:"PMT"})

				this.$store.dispatch('setfiberName', {x:5, y:1, value:"PMT_03"})
				this.$store.dispatch('setfiberType', {x:5, y:1, value:"PMT"})

				this.$store.dispatch('setfiberName', {x:5, y:2, value:"PMT_04"})
				this.$store.dispatch('setfiberType', {x:5, y:2, value:"PMT"})


				this.$store.dispatch('setfiberName', {x:7, y:1, value:"PY_01_01"})
				this.$store.dispatch('setfiberType', {x:7, y:1, value:"PY"})

				this.$store.dispatch('setfiberName', {x:7, y:2, value:"PY_01_02"})
				this.$store.dispatch('setfiberType', {x:7, y:2, value:"PY"})

				this.$store.dispatch('setfiberName', {x:7, y:3, value:"PY_03_01"})
				this.$store.dispatch('setfiberType', {x:7, y:3, value:"PY"})

				this.$store.dispatch('setfiberName', {x:7, y:3, value:"PY_02_02"})
				this.$store.dispatch('setfiberType', {x:7, y:3, value:"PY"})

				this.$store.dispatch('setfiberName', {x:2, y:3, value:"PY_03_02"})
				this.$store.dispatch('setfiberType', {x:2, y:3, value:"PY"})

				this.$store.dispatch('setfiberName', {x:4, y:2, value:"PY_01_03"})
				this.$store.dispatch('setfiberType', {x:4, y:2, value:"PY"})

				this.$store.dispatch('setfiberName', {x:1, y:1, value:"PY_01_04"})
				this.$store.dispatch('setfiberType', {x:1, y:1, value:"PY"})



				let tcrn
				let self = this
				this.fiberNames.forEach(function(element){
					tcrn = 20
					

					self.$store.dispatch("setOvenTcrn", {fiberType:element, value:tcrn})
					self.$store.dispatch("setOvenFitM", {oven:element, value:0.02})
					self.$store.dispatch("setOvenFitC", {oven:element, value:655.66})
				})
			}
		},
		mounted(){
			this.init()
			setInterval(this.simulate,3000)
		},
		data(){
			return {
				fiberNames : [
				'PY_01_PI', 'PY_01_SIGMA', 'PY_01_BG1', 'PY_01_BG2', 'PY_02_PI', 'PY_02_SIGMA', 'PY_02_BG1', 'PY_02_BG2', 'PY_03_PI', 'PY_03_SIGMA', 'PY_03_BG1', 'PY_03_BG2', 'PY_04_PI', 'PY_04_SIGMA', 'PY_04_BG1', 'PY_04_BG2', 'PMT_01', 'PMT_02', 'PMT_03', 'PMT_04', 'PMT_05', 'PMT_06', 'PMT_07', 'PMT_08', 'PMT_09', 'PMT_10' 
				],

			}

		},
		computed: {
			ovens(){
				return this.$store.getters.ovens
			}
		},
	}
</script>